module.exports = __webpack_public_path__ + "static/biometrics-34636eef4b9259d533d77cac2403f946.jpeg";